import { IDUSUARIO, GENERIC_URL, customAxios, USERNAME } from '../constants';
import { FETCH_CLIENTES, CLEAR_CLIENTES, FETCH_DIRECCIONES_CLIENTE, FETCH_CLIENTES_PEDIDOS } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchClientes(option, value, numPag = '1') {
  const data = {
    [option]: value,
  };

  const config = {
    headers: {
      numPag,
      idUsuario: IDUSUARIO,
      cantiRegPag: '10',
    },
  };

  const request = customAxios.post(`${GENERIC_URL}/cliente/listar`, data, config)
  .then(({ data }) => evalAction(data, 'clienteListar'))
.catch(error => serverError(error, 'clienteListar'));

  return {
    type: FETCH_CLIENTES,
    payload: request,
  };
}

export function clearClientes() {
  return {
    type: CLEAR_CLIENTES,
  };
}

export function fetchDireccionesCliente(cliente) {
  const data = {
    codCliente: cliente,
    codDireccion: '',
    estadoTrama: '',
    mensaje: '',
  };
  const config = {
    headers: {
      codUsuario: USERNAME,
    },
  };
  const request = customAxios.post(`${GENERIC_URL}/cliente/detalleDirecionListar`,data, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'));

  return {
    type: FETCH_DIRECCIONES_CLIENTE,
    payload: request,
  };
}

export function fetchClientesPedidos(option, value, numPag = '1') {
  const data = {
    [option]: value,
  };

  const config = {
    headers: {
      numPag,
      idUsuario: IDUSUARIO,
      cantiRegPag: '10',
    },
  };

  const request = customAxios.post(`${GENERIC_URL}/cliente/clientes-pedidos`, data, config)
  .then(({ data }) => evalAction(data, 'clientesPedidos'))
  .catch(error => serverError(error, 'clientesPedidos'));
  return {
    type: FETCH_CLIENTES_PEDIDOS,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/Clientes.js